<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-card card-padding-top">
                <app-empty-content [isVisible]="data.length === 0"
                    title="Nenhum anexo encontrado"
                    description="Não foi encontrado nenhum anexo nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="dash-card-body" *ngIf="data.length > 0">
                    <div class="dash-card-scroll">
                        <table>
                            <thead>
                                <tr class="alternative-header">
                                    <th>Nome</th>
                                    <th>Responsável</th>
                                    <th>Data de cadastro</th>
                                    <th>Fim validade</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of data"
                                    class="alternative-header">
                                    <td style="max-width: 500px;">
                                        <div class="dash-card-item">
                                            <div>
                                                <span>
                                                    <img
                                                        src="{{renderIcon(item.files[0])}}" />
                                                </span>
                                            </div>

                                            <app-spacer
                                                [right]="16"></app-spacer>

                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    {{item.label ?? '--'}}
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    {{item.files.length > 1 ?
                                                    item.files.length + '
                                                    arquivos'
                                                    : '1 arquivo'}}
                                                </div>
                                            </div>

                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item">
                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    {{formatPartnerName(item.files[0])}}
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    <ng-container
                                                        *ngIf="item.files[0].referent === 'register' || item.files[0].referent_id === 'register'">
                                                        {{getTitularDocument()}}
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="item.files[0].referent === 'representative'">
                                                        {{getRepresentativeSubtitle(item.files[0])}}
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="item.files[0].referent !== 'register' && item.files[0].referent_id !== 'register' && item.files[0].referent !== 'representative'">
                                                        {{formatAttachmentType(item.files[0].referent)}}
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item">
                                            <div class="dash-card-item-content-title"
                                                *ngIf="item.files[0].date_due">
                                                {{ item.files[0].date_due |
                                                date:'dd/MM/yyyy' }}
                                            </div>

                                            <div class="dash-card-item-content-title"
                                                *ngIf="!item.files[0].date_due">
                                                {{
                                                getAttachmentDate('start',
                                                item.files[0].date_created) }}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item">
                                            <div class="dash-card-item-content-title"
                                                *ngIf="item.files[0].end_date_due">
                                                {{ item.files[0].end_date_due |
                                                date:'dd/MM/yyyy' }}
                                            </div>

                                            <div class="dash-card-item-content-title"
                                                *ngIf="!item.files[0].end_date_due">
                                                {{
                                                getAttachmentDate('end',
                                                item.files[0].date_created) }}
                                            </div>
                                        </div>
                                    </td>

                                    <td>
                                        <div
                                            class="d-flex align-items-center justify-content-end">
                                            <app-tooltip text="Visualizar">
                                                <button class="button"
                                                    (click)="openFile(item.files)"
                                                    *ngIf="canView">
                                                    <svg-icon
                                                        src="assets/images/icon-eye.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                            <app-spacer [bottom]="28"></app-spacer>
                        </table>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <!-- Skeleton para versão principal -->
            <ng-container
                *ngIf="mainLoading && approvalService.approvalData.mainVersion">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container
                *ngIf="!mainLoading && approvalService.approvalData.mainVersion">
                <div class="dash-card card-padding-top">
                    <app-empty-content [isVisible]="mainData.length === 0"
                        title="Nenhum anexo encontrado"
                        description="Não foi encontrado nenhum anexo nesse cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>

                    <div class="dash-card-body" *ngIf="mainData.length > 0">
                        <div class="dash-card-scroll">
                            <table>
                                <thead>
                                    <tr class="alternative-header">
                                        <th>Nome</th>
                                        <th>Responsável</th>
                                        <th>Data de cadastro</th>
                                        <th>Fim validade</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of mainData"
                                        class="alternative-header">
                                        <td style="max-width: 500px;">
                                            <div class="dash-card-item">
                                                <div>
                                                    <span>
                                                        <img
                                                            src="{{renderIcon(item.files[0]?.file)}}" />
                                                    </span>
                                                </div>

                                                <app-spacer
                                                    [right]="16"></app-spacer>

                                                <div
                                                    class="dash-card-item-content">
                                                    <div
                                                        class="dash-card-item-content-title">
                                                        {{item.label ?? '--'}}
                                                    </div>
                                                    <div
                                                        class="dash-card-item-content-subtitle">
                                                        {{item.files.length > 1
                                                        ?
                                                        item.files.length + '
                                                        arquivos'
                                                        : '1 arquivo'}}
                                                    </div>
                                                </div>

                                            </div>
                                        </td>
                                        <td>
                                            <div class="dash-card-item">
                                                <div
                                                    class="dash-card-item-content">
                                                    <div
                                                        class="dash-card-item-content-title">
                                                        {{formatPartnerName(item.files[0],
                                                        'main')}}
                                                    </div>
                                                    <div
                                                        class="dash-card-item-content-subtitle">
                                                        <ng-container
                                                            *ngIf="item.files[0].referent === 'register' || item.files[0].referent_id === 'register'">
                                                            {{getTitularDocument()}}
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="item.files[0].referent === 'representative'">
                                                            {{getRepresentativeSubtitle(item.files[0],
                                                            'main')}}
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="item.files[0].referent !== 'register' && item.files[0].referent_id !== 'register' && item.files[0].referent !== 'representative'">
                                                            {{formatAttachmentType(item.files[0].referent)}}
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="dash-card-item">
                                                <div class="dash-card-item-content-title"
                                                    *ngIf="item.files[0].date_due">
                                                    {{ item.files[0].date_due |
                                                    date:'dd/MM/yyyy' }}
                                                </div>

                                                <div class="dash-card-item-content-title"
                                                    *ngIf="!item.files[0].date_due">
                                                    {{
                                                    getAttachmentDate('start',
                                                    item.files[0].date_created)
                                                    }}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="dash-card-item">
                                                <div class="dash-card-item-content-title"
                                                    *ngIf="item.files[0].end_date_due">
                                                    {{
                                                    item.files[0].end_date_due |
                                                    date:'dd/MM/yyyy' }}
                                                </div>

                                                <div class="dash-card-item-content-title"
                                                    *ngIf="!item.files[0].end_date_due">
                                                    {{
                                                    getAttachmentDate('end',
                                                    item.files[0].date_created)
                                                    }}
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <div
                                                class="d-flex align-items-center justify-content-end">
                                                <app-tooltip text="Visualizar">
                                                    <button class="button"
                                                        (click)="openFile(item.files)"
                                                        *ngIf="canView">
                                                        <svg-icon
                                                            src="assets/images/icon-eye.svg"></svg-icon>
                                                    </button>
                                                </app-tooltip>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                                <app-spacer [bottom]="28"></app-spacer>
                            </table>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!approvalService.approvalData.mainVersion">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="approvalService.approvalData.comparingVersion">
                <!-- Skeleton para tabela de anexos -->
                <ngx-skeleton-loader *ngIf="comparingDataLoading" [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>

                <div class="row" *ngIf="!comparingDataLoading">
                    <div class="col-12">
                        <div class="dash-card card-padding-top">
                            <app-empty-content
                                [isVisible]="comparingData.length === 0"
                                title="Nenhum anexo encontrado"
                                description="Não foi encontrado nenhum anexo nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <div class="dash-card-body"
                                *ngIf="comparingData.length > 0">
                                <div class="dash-card-scroll">
                                    <table>
                                        <thead>
                                            <tr class="alternative-header">
                                                <th>Nome</th>
                                                <th>Responsável</th>
                                                <th>Data de cadastro</th>
                                                <th>Fim validade</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of comparingData"
                                                class="alternative-header"
                                                [class]="item.compareClass">
                                                <td style="max-width: 500px;">
                                                    <div class="dash-card-item"
                                                        style="display: flex; align-items: center; gap: 6px;">
                                                        <div *ngIf="item.compareClass === 'row-compare-added'"
                                                            style="flex-shrink: 0;">
                                                            <img
                                                                src="/assets/images/carbon-checkmark.svg"
                                                                class="comparison-icon" alt="adicionado" />
                                                        </div>
                                                        <div *ngIf="item.compareClass === 'row-compare-removed'"
                                                            style="flex-shrink: 0;">
                                                            <img
                                                                src="/assets/images/carbon-error-warning.svg"
                                                                class="comparison-icon" alt="removido" />
                                                        </div>
                                                        <div
                                                            style="display: flex; align-items: center;">
                                                            <div>
                                                                <span>
                                                                    <img
                                                                        src="{{renderIcon(item.files[0]?.file)}}" />
                                                                </span>
                                                            </div>

                                                            <app-spacer
                                                                [right]="16"></app-spacer>

                                                            <div
                                                                class="dash-card-item-content">
                                                                <div class="dash-card-item-content-title"
                                                                    [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                    <span
                                                                        *ngIf="item.changedFields?.label"
                                                                        style="margin-right: 6px;">
                                                                        <img
                                                                            src="/assets/images/carbon-warning.svg"
                                                                            class="comparison-icon" alt="alterado" />
                                                                    </span>
                                                                    {{item.label
                                                                    ?? '--'}}
                                                                </div>
                                                                <div
                                                                    class="dash-card-item-content-subtitle">
                                                                    {{item.files.length
                                                                    > 1
                                                                    ?
                                                                    item.files.length
                                                                    + '
                                                                    arquivos'
                                                                    : '1
                                                                    arquivo'}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="dash-card-item"
                                                        style="display: flex; align-items: center; gap: 6px;">
                                                        <div *ngIf="item.changedFields?.responsible"
                                                            style="flex-shrink: 0;">
                                                            <img
                                                                src="/assets/images/carbon-warning.svg"
                                                                class="comparison-icon" alt="alterado" />
                                                        </div>
                                                        <div
                                                            class="dash-card-item-content">
                                                            <div class="dash-card-item-content-title"
                                                                [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                {{formatPartnerName(item.files[0],
                                                                'comparing')}}
                                                            </div>
                                                            <div
                                                                class="dash-card-item-content-subtitle">
                                                                {{(item.files[0].referent
                                                                === 'register'
                                                                ||
                                                                item.files[0].referent_id
                                                                === 'register')
                                                                ?
                                                                getTitularName()
                                                                :
                                                                formatAttachmentType(item.files[0].referent)}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="dash-card-item"
                                                        style="display: flex; align-items: center; gap: 6px;">
                                                        <div *ngIf="item.changedFields?.date_created"
                                                            style="flex-shrink: 0;">
                                                            <img
                                                                src="/assets/images/carbon-warning.svg"
                                                                class="comparison-icon" alt="alterado" />
                                                        </div>
                                                        <div>
                                                            <div class="dash-card-item-content-title"
                                                                *ngIf="item.files[0].date_due"
                                                                [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                {{
                                                                item.files[0].date_due
                                                                |
                                                                date:'dd/MM/yyyy'
                                                                }}
                                                            </div>

                                                            <div class="dash-card-item-content-title"
                                                                *ngIf="!item.files[0].date_due"
                                                                [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                {{
                                                                getAttachmentDate('start',
                                                                item.files[0].date_created)
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="dash-card-item"
                                                        style="display: flex; align-items: center; gap: 6px;">
                                                        <div *ngIf="item.changedFields?.end_date_due"
                                                            style="flex-shrink: 0;">
                                                            <svg-icon
                                                                src="assets/images/icon-warning.svg"
                                                                class="text-warning"></svg-icon>
                                                        </div>
                                                        <div>
                                                            <div class="dash-card-item-content-title"
                                                                *ngIf="item.files[0].end_date_due"
                                                                [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                {{
                                                                item.files[0].end_date_due
                                                                |
                                                                date:'dd/MM/yyyy'
                                                                }}
                                                            </div>

                                                            <div class="dash-card-item-content-title"
                                                                *ngIf="!item.files[0].end_date_due"
                                                                [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                {{
                                                                getAttachmentDate('end',
                                                                item.files[0].date_created)
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div
                                                        class="d-flex align-items-center justify-content-end">
                                                        <app-tooltip
                                                            text="Visualizar">
                                                            <button
                                                                class="button"
                                                                (click)="openFile(item.files)"
                                                                *ngIf="canView">
                                                                <svg-icon
                                                                    src="assets/images/icon-eye.svg"></svg-icon>
                                                            </button>
                                                        </app-tooltip>
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                        <app-spacer [bottom]="28"></app-spacer>
                                    </table>
                                </div>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.comparingVersion">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>


<form [formGroup]="reproveForm">
    <app-side-modal [active]="reproveModal" title="Solicitar novo documento"
        (onClose)="closeModal()" paddingBottom="0">
        <div class="container">
            <div class="row">
                <div class="col-12 modal-text-title">
                    <h3>Nome do documento</h3>
                    <p>{{selectedAttachment?.type?.name}}</p>
                </div>

                <div class="col-12">
                    <app-input type="textarea" [group]="reproveForm"
                        controlName="description" [rows]="4"
                        label="Esclareça como deve ser o documento esperado"
                        [noResize]="true">
                    </app-input>

                    <app-spacer [bottom]="48"></app-spacer>
                </div>
            </div>

            <div class="row button-sticky">
                <div class="col-12 col-lg-6">
                    <app-button (onClick)="closeModal()" class="add-button"
                        [outline]="true">
                        Cancelar
                    </app-button>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="text-right">
                        <app-button (onClick)="handleReproveDocument()"
                            class="add-button"
                            [disabled]="this.reproveForm.invalid">
                            Reprovar documento
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </app-side-modal>
</form>

<app-warning-modal [active]="warningModal" (onClose)="closeModal()">
    <h3>Atenção</h3>
    <app-spacer [bottom]="24"></app-spacer>
    <p>Você tem certeza que deseja reprovar o documento Comprovante de
        residência enviado por SOCINAL S.A?</p>
    <app-spacer [bottom]="56"></app-spacer>

    <app-button (onClick)="openReproveModal()" [center]="true" [danger]="true">
        Sim, quero reprovar agora
    </app-button>
    <app-spacer [bottom]="8"></app-spacer>
    <app-button (onClick)="closeModal()" [center]="true" class="add-button">
        Não, pode manter
    </app-button>
</app-warning-modal>

<app-modal #modalRoot class="modal-demo">
    <ng-container class="app-modal-header">
        <ng-container *ngIf="selectedFile">
            <svg-icon src="assets/images/icon_drag_indicator.svg"></svg-icon>
            <div class="text-center">{{modalFiles[0].type?.name}}</div>
            <div></div>
        </ng-container>
    </ng-container>

    <ng-container class="app-modal-body">
        <ng-container *ngIf="selectedFile">
            <img [src]="selectedFile.url" *ngIf="selectedFile.isImg"
                style="width:100%">

            <iframe [src]="selectedFile.url" *ngIf="!selectedFile.isImg"
                frameborder="0" height="100%" width="100%">
            </iframe>
        </ng-container>
    </ng-container>

    <ng-container class="app-modal-footer">
        <div class="attachment-modal-navigation">
            <button class="attachment-modal-navigation-arrow"
                (click)="setPrevAttachment()" [disabled]="getDisabled('prev')">
                <svg-icon src="assets/images/icon-left.svg"></svg-icon>
            </button>

            <div class="pl-3 pr-3">{{selectedFile?.name ?
                urlDecoding(selectedFile.name) : ''}}</div>

            <button class="attachment-modal-navigation-arrow"
                (click)="setNextAttachment()" [disabled]="getDisabled('next')">
                <svg-icon src="assets/images/icon-right.svg"></svg-icon>
            </button>
        </div>
    </ng-container>
</app-modal>